module.exports = __webpack_public_path__ + "img/dreams-5-gen-pro-portrait.16ee8f5.png";